import { Component, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as Jquery from 'jquery';


import { MoneyFormatPipe } from '../../pipes/money-format.pipe';

@Injectable()
export class FormatNumberInputProvider {
    constructor(
        private moneyFormatPipe: MoneyFormatPipe,
    ) {
    }

    formatNumber(elm){
        var decimal_separator = '.';
        var indexDecimalSeprator = String(elm.value).indexOf(decimal_separator)
        if (indexDecimalSeprator !== -1 && indexDecimalSeprator !== elm.value.length - 1){
            return this.formatNumberDecimal(elm)
        }
        else{
            return this.formatNumberNonDecimal(elm)
        }
    }

    private formatNumberNonDecimal(elm){
        var _back = false;
        var _delete = false;
        var res;

        let value = String(elm.value).replace(new RegExp(',', 'g'),'');
        // caret: vị trí dấu nháy
        var caretPosition = elm.selectionStart;
        
        var dotRegex = '.';
        var indexDot = elm.value.indexOf(dotRegex);
        if (indexDot !== -1 && indexDot >= caretPosition - 1){
            return elm.value;
        }

        var decimalvalue = '';
        if (indexDot !== -1){
            decimalvalue = elm.value.substring(indexDot);
            elm.value = elm.value.substring(0, indexDot);
            elm.old = elm.old.substring(0, elm.old.indexOf(dotRegex));
        }

        let oldLength = elm.value.length;
        let oldValue = String(elm.old).replace(new RegExp(',', 'g'),'');
        let oldCaret = elm.oldCaret;
        if (isNaN(Number(value))){
            res = 0;
            return res;
        }

        if (elm.old === elm.value){
            return elm.value + decimalvalue;
        }
        
        if (oldCaret > caretPosition){
            _back = true;
        }
        if (oldCaret == caretPosition){
            _delete = true;
        }

        // Check nếu nhấn nút back/delete ngay sau dấu phân cách (dấu phẩy)
        if (Number(value) == Number(oldValue)){
            var newValue = elm.value;
            // Trường hợp bấm nút back
            if (_back == true){
                newValue = String(elm.value).substr(0, caretPosition - 1) + String(elm.value).substring(caretPosition);
            }
            // Trường hợp bấm nút delete
            if (_delete == true){
                newValue = String(elm.value).substr(0, caretPosition) + String(elm.value).substring(caretPosition + 1);
            }
            elm.value = newValue;
        }
        newValue = String(elm.value).replace(new RegExp(',', 'g'),'');
        res = newValue;

        newValue = this.moneyFormatPipe.transform(newValue);
        elm.value = newValue;
        let newLength = newValue.length;

        if (newLength - oldLength > 0){
            caretPosition += (newLength - oldLength);
        }
        else{
            if (Number(value) == Number(oldValue)){
                if (_delete){
                    caretPosition += (newLength - oldLength) + 1;
                }
                if (_back && newLength < oldLength){
                    caretPosition -= (oldLength - newLength);
                }
            }
            else{
                if ((_delete || _back) && newLength < oldLength){
                    caretPosition -= (oldLength - newLength);
                }
            }
        }

        caretPosition = caretPosition < 0 ? 0 : caretPosition;
        elm.focus(); 
        elm.setSelectionRange(caretPosition, caretPosition);

        return res + decimalvalue.toString();
    }

    private formatNumberDecimal(elm) {
        var _back = false;
        var _delete = false;
        var res;

        // caret: vị trí dấu nháy
        var caretPosition = elm.selectionStart;
        
        var decimal_separator = '.';
        var split = elm.value.split(decimal_separator);
        var indexDot = elm.value.indexOf(decimal_separator);
        if (!split[1]){
            var tempval = split[0].replace(new RegExp(',','g'),'');
            return elm.value.replace(new RegExp(',','g'),'');
        }

        if (caretPosition > indexDot){
            return elm.value.replace(new RegExp(',','g'),'');
        }

        var decimalvalue = '';
        decimalvalue = split[1];
        elm.value = split[0];
        elm.old = elm.old.split(decimal_separator)[0];

        let value = String(elm.value).replace(new RegExp(',', 'g'),'');
        let oldLength = elm.value.length;
        let oldValue = String(elm.old).replace(new RegExp(',', 'g'),'');
        let oldCaret = elm.oldCaret;
        if (isNaN(Number(value))){
            res = 0;
            return res;
        }

        if (elm.old === elm.value){
            return value + '.' + decimalvalue;
        }
        
        if (oldCaret > caretPosition){
            _back = true;
        }
        if (oldCaret == caretPosition){
            _delete = true;
        }

        // Check nếu nhấn nút back/delete ngay sau dấu phân cách (dấu phẩy)
        if (Number(value) == Number(oldValue)){
            var newValue = elm.value;
            // Trường hợp bấm nút back
            if (_back == true){
                newValue = String(elm.value).substr(0, caretPosition - 1) + String(elm.value).substring(caretPosition);
            }
            // Trường hợp bấm nút delete
            if (_delete == true){
                newValue = String(elm.value).substr(0, caretPosition) + String(elm.value).substring(caretPosition + 1);
            }
            elm.value = newValue;
        }
        newValue = String(elm.value).replace(new RegExp(',', 'g'),'');
        res = newValue;

        newValue = this.moneyFormatPipe.transform(newValue);
        elm.value = newValue;
        let newLength = newValue.length;

        if (newLength - oldLength > 0){
            caretPosition += (newLength - oldLength);
        }
        else{
            if (Number(value) == Number(oldValue)){
                if (_delete){
                    caretPosition += (newLength - oldLength) + 1;
                }
                if (_back && newLength < oldLength){
                    caretPosition -= (oldLength - newLength);
                }
            }
            else{
                if ((_delete || _back) && newLength < oldLength){
                    caretPosition -= (oldLength - newLength);
                }
            }
        }

        caretPosition = caretPosition < 0 ? 0 : caretPosition;
        elm.focus(); 

        res = res + '.' + decimalvalue.toString();
        elm.value = newValue + '.' + decimalvalue.toString();
        elm.setSelectionRange(caretPosition, caretPosition);

        return res;
    }
    
    preventNonNumber(event, elm = null, maxDecimalPrecision = 0){
        var decimal_separator = '.';

        if (elm != null){
            elm.oldCaret = elm.selectionStart;
            elm.old = elm.value;
        }

        // Check các ký tự với length = 1 (chữ, số, ...) với tổ hợp phím của ctrl
        if (event.key.length <= 1 && !(event.ctrlKey)){
            if ((isNaN(Number(event.key)) || event.key === ' ')){
                // check dấu phân cách thập phân
                if (event.key != '.' || maxDecimalPrecision <= 0){
                    event.preventDefault();
                    return;
                }

                // Check xem đã có dấu '.' trong chuỗi chưa
                var dotRegex = '.';
                if (elm.value.indexOf(dotRegex) >= 0){
                    event.preventDefault();
                    return;
                }
            }
            
            var caretPosition = elm.selectionStart;
            var indexDot = elm.value.indexOf(decimal_separator);
            if (caretPosition > indexDot && maxDecimalPrecision != 0){
                var split = elm.value.split(decimal_separator);
                if (split[1] && split[1].length == maxDecimalPrecision && !isNaN(Number(event.key))){
                    event.preventDefault();
                    return;
                }
            }
        }
    }

    digitInfo(input: number): string {
        // console.log('1.0' + '-' + input.toString());
        return '1.' + input.toString() + '-' + input.toString();
    }
}
